import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { TeamDto } from "./teams.dto";

export class TeamsResponseModel extends GlobalResponseObject{
    data?: TeamDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: TeamDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}